import { Box, Button, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate, useParams } from "react-router";

// Documentos publicados (mkdocs estático em public/ajuda). Abertos DENTRO do
// app (iframe), com o AppShell em volta — mesmo enquadramento do sistema, em
// vez de uma aba solta com o tema do Material.
const DOCS: Record<string, { file: string; title: string }> = {
  manual: { file: "manual-sistema.html", title: "Manual do sistema" },
  perguntas: { file: "perguntas-e-respostas.html", title: "Perguntas & Respostas" },
  fluxo: { file: "fluxo_logico.html", title: "Fluxo de implantação" },
};

export function AjudaPage() {
  const navigate = useNavigate();
  const { doc = "manual" } = useParams();
  const entry = DOCS[doc] ?? DOCS.manual;
  const src = `${import.meta.env.BASE_URL}ajuda/${entry.file}`;
  const voltar = () => (window.history.length > 1 ? navigate(-1) : navigate("/"));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={voltar} data-testid="ajuda-voltar">
          Voltar
        </Button>
        <Typography variant="h6" sx={{ flex: 1 }}>{entry.title}</Typography>
        <Button size="small" endIcon={<OpenInNewIcon />} onClick={() => window.open(src, "_blank", "noopener,noreferrer")}>
          Abrir em nova aba
        </Button>
      </Stack>
      <Box
        component="iframe"
        key={src}
        src={src}
        title={entry.title}
        sx={{ width: "100%", height: "calc(100vh - 160px)", border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "background.paper" }}
      />
    </Box>
  );
}
